/** Figma sidebar nav icons — 20px, Grey/950 · dark: Base/White */
export const SIDEBAR_NAV_ICON_SIZE = 20;
export const SIDEBAR_NAV_ICON_STROKE = 1.75;

export const sidebarNavIconClass =
  'shrink-0 text-[hsl(var(--grey-950))] dark:text-true-white';
